import * as React from "react"

import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, spellCheck, lang, autoCorrect, autoCapitalize, ...props }, ref) => {
    return (
      <textarea
        spellCheck={spellCheck ?? true}
        lang={lang ?? "es"}
        autoCorrect={autoCorrect ?? "on"}
        autoCapitalize={autoCapitalize ?? "sentences"}
        translate="yes"
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-border/30 px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200",
          "bg-[hsl(var(--input-background))]",
          "focus-visible:shadow-[0_0_20px_hsl(217_91%_60%_/_0.3)]",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
